const ENV = {
  isDev: () => process.env.NODE_ENV === "development",
  // use window.env (defined in "public/etc/env.js") if running in production
  get: () => (ENV.isDev() ? process.env : window.env),
};
export default ENV;
